import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    productLoader: false,
    productDetails: '',
    productError: '',
    catalogueLoader: false,
    catalogueDetails: '',
    catalogueError: '',
    categoryLoader: false,
    categoryDetails: '',
    categoryError: '',
    clientProductcatalogueLoader: false,
    clientProductcatalogueDetails: '',
    clientProductcatalogueError: '',
    clientProductcategoryLoader: false,
    clientProductcategoryDetails: '',
    clientProductcategoryError: '',
    brandLoader: false,
    brandDetails: '',
    brandError: '',
    providerLoader: false,
    providerDetails: '',
    providerError: '',
    planLoader: false,
    planDetails: '',
    planError: '',
};

export default function younoteAdminProductReducer(state = initState, action) {
    switch (action.type) {
        case actions.PRODUCT_DETAILS_START: {
            return {
                ...state,
                productLoader: true,
            };
        }
        case actions.PRODUCT_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                productLoader: false,
                productDetails: action.payload,
            };
        }
        case actions.PRODUCT_DETAILS_FAILURE: {
            return {
                ...state,
                productLoader: false,
                productError: action.message,
            };
        }

        case actions.PLAN_DETAILS_START: {
            return {
                ...state,
                planLoader: true
            };
        }
        case actions.PLAN_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                planDetails: action.payload,
                planLoader: false,
            };
        }
        case actions.PLAN_DETAILS_FAILURE: {
            return {
                ...state,
                planLoader: false,
                planError: action.message,
            };
        }

        case actions.CATALOGUE_DETAILS_START: {
            return {
                ...state,
                catalogueLoader: true,
            };
        }
        case actions.CATALOGUE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                catalogueLoader: false,
                catalogueDetails: action.payload,
            };
        }
        case actions.CATALOGUE_DETAILS_FAILURE: {
            return {
                ...state,
                catalogueLoader: false,
                catalogueError: action.message,
            };
        }

        case actions.CATEGORY_DETAILS_START: {
            return {
                ...state,
                categoryLoader: true,
            };
        }
        case actions.CATEGORY_DETAILS_SUCCESS: {
            return {
                ...state,
                categoryLoader: false,
                categoryDetails: action.payload,
            };
        }
        case actions.CATEGORY_DETAILS_FAILURE: {
            return {
                ...state,
                categoryLoader: false,
                categoryError: action.message,
            };
        }

        case actions.CLIENT_PRODUCT_CATALOGUE_DETAILS_START: {
            return {
                ...state,
                clientProductcatalogueLoader: true,
            };
        }
        case actions.CLIENT_PRODUCT_CATALOGUE_DETAILS_SUCCESS: {
            return {
                ...state,
                clientProductcatalogueLoader: false,
                clientProductcatalogueDetails: action.payload,
            };
        }
        case actions.CLIENT_PRODUCT_CATALOGUE_DETAILS_FAILURE: {
            return {
                ...state,
                clientProductcatalogueLoader: false,
                clientProductcatalogueError: action.message,
            };
        }

        case actions.CLIENT_PRODUCT_CATEGORY_DETAILS_START: {
            return {
                ...state,
                clientProductcategoryLoader: true,
            };
        }
        case actions.CLIENT_PRODUCT_CATEGORY_DETAILS_SUCCESS: {
            return {
                ...state,
                clientProductcategoryLoader: false,
                clientProductcategoryDetails: action.payload,
            };
        }
        case actions.CLIENT_PRODUCT_CATEGORY_DETAILS_FAILURE: {
            return {
                ...state,
                clientProductcategoryLoader: false,
                clientProductcategoryError: action.message,
            };
        }

        case actions.BRAND_DETAILS_START: {
            return {
                ...state,
                brandLoader: true,
            };
        }
        case actions.BRAND_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                brandLoader: false,
                brandDetails: action.payload,
            };
        }
        case actions.BRAND_DETAILS_FAILURE: {
            return {
                ...state,
                brandLoader: false,
                brandError: action.message,
            };
        }
        case actions.PROVIDER_DETAILS_START: {
            return {
                ...state,
                providerLoader: true,
            };
        }
        case actions.PROVIDER_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                providerLoader: false,
                providerDetails: action.payload,
            };
        }
        case actions.PROVIDER_DETAILS_FAILURE: {
            return {
                ...state,
                providerLoader: false,
                providerError: action.message,
            };
        }


        case actions.CLEAR_ADMIN_PRODUCT_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_ADMIN_PRODUCT_DETAILS_SUCCESS: {
            return initState;
        }

        default:
            return state;
    }
}